import * as marietta from '../..';
import ItemController from './ItemController';

export default class ItemControllerWallMountedItems extends ItemController {
  /**
   *コンストラクタ
   * @param _target
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    // 特定アイテムは、リサイズ不可
    this.dragObj_T.hide();
    this.dragObj_TL.hide();
    this.dragObj_TR.hide();
    this.dragObj_L.hide();
    this.dragObj_R.hide();
    this.dragObj_B.hide();
    this.dragObj_BL.hide();
    this.dragObj_BR.hide();
  }

  /**
     * ターゲットに合わせて各種パーツリサイズ
     */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();

    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);

    // SVGSpriteのwidth/heightに書き換え
    const { width } = this.target.spt;
    const { height } = this.target.spt;

    // ピッカー
    this.dragObj_T.move(0, 0);
    this.dragObj_TL.move(-width / 2, 0);
    this.dragObj_TR.move(width / 2, 0);
    this.dragObj_L.move(-width / 2, 0);
    this.dragObj_R.move(width / 2, 0);
    this.dragObj_B.move(0, height);
    this.dragObj_BL.move(-width / 2, height);
    this.dragObj_BR.move(width / 2, height);

    this.rotator.move(-6.5, (0 - 25));

    // アイコンボタンの位置更新
    this.updateIconButtons();

    // 全体Box
    // rectのwidth/heightプロパティに値が代入出来ないので
    // 直接渡すことに（Firefoxのみ値渡しが出来ていたっぽい）
    this.allBox.resize({ width, height });
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);

    // 回転角度を元に戻す
    this.target.rotate(motoRot);

    this.rotation = motoRot;
    this.updateTransforms();
  }

  /**
   * 回転の開始（位置のリセット）
   * @param MouseEvent
   */
   rotateStart = () => {
     this.x = this.target.itemInfo.x;
     this.y = this.target.itemInfo.y;
     this.updateTransforms();

     const { width } = this.target.spt;
     const { height } = this.target.spt;

     // ピッカー
     this.dragObj_T.move(0, 0);
     this.dragObj_TL.move(-width / 2, 0);
     this.dragObj_TR.move(width / 2, 0);
     this.dragObj_L.move(-width / 2, 0);
     this.dragObj_R.move(width / 2, 0);
     this.dragObj_B.move(0, height);
     this.dragObj_BL.move(-width / 2, height);
     this.dragObj_BR.move(width / 2, height);
     this.rotator.move(-6.5, -25);

     this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
   };
}
